import './CleanPanel.scss';

const CleanPanel = ({ children }: { children: React.ReactNode }) => {
  return <div className="cleanPanel">{children}</div>;
};

export default CleanPanel;
